<!-- Contacts Section -->
<div class="surface-section p-3 border-round-lg shadow-1" 
     style="background-color: var(--surface-card);">
  <div class="text-lg font-semibold text-900 mb-3">
    <i class="pi pi-users mr-2 mb-3"></i>
    Address Contacts
    <span *ngIf="selectedCustomer.selectedAddressId === null" class="text-sm font-normal text-primary ml-2">
      (for new address)
    </span>
  </div>
  <div class="flex flex-column gap-3">
    <!-- Show existing contacts -->
    <div *ngFor="let contact of selectedCustomer.selectedAddressContacts; let i = index" 
         class="p-2 border-1 border-200 border-round">
      <div class="flex align-items-center gap-2 mb-2">
        <span class="font-medium text-sm">Contact {{i + 1}}</span>
        <div class="flex-1"></div>
        <button pButton 
                type="button" 
                icon="pi pi-trash" 
                (click)="onDeleteContactClick(selectedCustomer, selectedCustomer.selectedAddress, contact, i)"
                class="p-button-rounded p-button-text p-button-sm p-button-danger"
                [style]="{'width': '24px', 'height': '24px'}"
                *ngIf="hasAccess && canShowDeleteContact(contact)"
                [pTooltip]="isNewContact(contact) ? 'Remove contact' : 'Delete Contact'"
                tooltipPosition="top">
        </button>
      </div>
      
      <div class="flex gap-2">
        <span class="p-float-label flex-1">
          <input pInputText 
                 id="contact_name_{{i}}" 
                 [(ngModel)]="contact.name" 
                 class="w-full" 
                 [class.ng-invalid]="!validateContact(contact) && contact.name !== undefined"
                 />
          <label for="contact_name_{{i}}">Name</label>
        </span>
        <span class="p-float-label flex-1">
          <input pInputText 
                 id="contact_email_{{i}}" 
                 [(ngModel)]="contact.email" 
                 type="email"
                 class="w-full" />
          <label for="contact_email_{{i}}">Email</label>
        </span>
        <span class="p-float-label flex-1">
          <input pInputText 
                 id="contact_phone_{{i}}" 
                 [(ngModel)]="contact.phone" 
                 class="w-full" />
          <label for="contact_phone_{{i}}">Phone</label>
        </span>
      </div>
      
      <!-- Validation message for individual contact -->
      <div *ngIf="!validateContact(contact) && contact.name !== undefined" 
           class="text-red-500 text-xs mt-1">
        <i class="pi pi-exclamation-triangle mr-1"></i>
        Contact name is required
      </div>
    </div>

    <!-- Show message when no contacts -->
    <div *ngIf="!hasContacts()" 
         class="text-center text-500 py-4">
      <i class="pi pi-info-circle mr-2"></i>
      No contacts available for this address
    </div>
    
    <!-- Add New Contact Button -->
    <div class="flex justify-content-center pt-2">
      <button pButton 
              label="Add Contact" 
              icon="pi pi-plus" 
              (click)="addNewContact()" 
              class="p-button-outlined p-button-sm"></button>
    </div>

    <!-- Validation summary -->
    <div *ngIf="!areContactsValid()" 
         class="bg-red-50 border-1 border-red-200 border-round p-2 mt-2">
      <div class="text-red-600 text-sm">
        <i class="pi pi-exclamation-triangle mr-1"></i>
        Please provide names for all contacts or remove empty entries
      </div>
    </div>
  </div>
</div>

